import { Address } from '@31third/common';

export class RebalancingAllocationEntryDto {
  public tokenAddress: Address;
  public allocation: number;
}
